<template>
  <div id="activity-table-container">
    <div class="activity-header-container">
      <SACTableSearch
        type="text"
        :search="activityTableSearch"
        @input="changeSearch"
      />
    </div>
    <div class="activity-container">
      <v-data-table
        :headers="headers"
        :items="activityTableData"
        :loading="loading"
        :search="activityTableSearch"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        height="700px"
        fixed-header
        hide-default-footer
        disable-pagination
      >
        <template #[`item.timestamp`]="{ item }">
          <td>
            <span>{{ formattedDate(item.timestamp) }}</span>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import SACTableSearch from '@shared/components/table/SACTableSearch.vue';

export default {
  name: 'ActivityTable',
  components: {
    SACTableSearch,
  },
  mixins: [unitPreferencesMixin],
  props: {
    activityTableData: Array,
    loading: Boolean,
    changeFilter: Function,
    changeAlertsType: Function,
    activityTableSearch: String,
  },
  data() {
    return {
      sortBy: 'timestamp',
      sortDesc: true,
      headers: [{
        text: 'Timestamp',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'timestamp',
      },
      {
        text: 'Event Code',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'eventCode',
      }, {
        text: 'Description',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'description',
      }, {
        text: 'Category/Alert Category',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'category',
      }, {
        text: 'Alert Type',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'alertType',
      }, {
        text: 'UID',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'uid',
      }, {
        text: 'Payload',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'payload',
      }],
    };
  },
  mounted() {
    this.$store.dispatch('getCustomerActivities');
  },
  methods: {
    changeSearch(value) {
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'activityTableSearch',
        value,
      });
    },
  },
};
</script>

<style lang="scss">

#activity-table-container {
  width: 100%;
  max-width: 1705px;
  .activity-header-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 18px;
  }
  .activity-container {
    background-color: $WHITE;
    box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
    border-radius: 6px;
    padding-bottom: 12px;
    .v-data-table__wrapper {
      height: 700px;
      thead {
        tr {
          th {
            background-color: $N100;
            text-transform: uppercase;
            color: $WHITE;
            font-size: 15px;
            font-weight: 500;
            .mdi-checkbox-blank-outline::before,
            .mdi-checkbox-marked::before,
            .mdi-minus-box::before,
            .mdi-arrow-up::before {
              color: $WHITE;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            border-bottom: 0;
          }
          &:hover {
            background: none;
          }
          &:nth-child(even) {
            background-color: $NBLUE5;
          }
        }
      }
    }
  }
}

</style>
